import type { useAdminProfiles } from '@/hooks/useAdminDirectory'
import { rowStyle, statusPillStyle } from './adminListStyles'

// Shared row list for a filtered slice of the platform-wide profiles directory
// (useAdminProfiles already covers every role — migration 066's "drivetrack admin read"
// policies). Used by AdminSchools (school admins), AdminInstructors, AdminStudents, and
// AdminAdmins (which renders its own richer row instead of this one, since it also needs
// a superadmin-tier toggle).
export function AdminProfileList({ profiles, loading, updating, onSetStatus }: {
  profiles: ReturnType<typeof useAdminProfiles>['profiles']
  loading: boolean
  updating: string | null
  onSetStatus: (id: string, status: 'active' | 'suspended') => Promise<{ ok: boolean; error?: string }>
}) {
  if (loading) return <div style={{ color: 'rgba(27,42,74,0.4)' }}>Loading…</div>
  if (profiles.length === 0) return <div style={{ color: 'rgba(27,42,74,0.4)' }}>None yet.</div>
  return (
    <>
      {profiles.map(p => (
        <div key={p.id} style={rowStyle}>
          <div style={{ flex: '1 1 200px', font: '600 13.5px Inter, sans-serif', color: '#1B2A4A' }}>
            {p.fullName ?? '(no name set)'}
          </div>
          <div style={{ flex: '1 1 220px', font: '400 12.5px Inter, sans-serif', color: 'rgba(27,42,74,0.55)' }}>
            {p.email}
          </div>
          <div style={statusPillStyle(p.accountStatus)}>{p.accountStatus}</div>
          <button
            onClick={() => onSetStatus(p.id, p.accountStatus === 'active' ? 'suspended' : 'active')}
            disabled={updating === p.id}
            style={{
              padding: '5px 12px', borderRadius: 7, border: '1px solid rgba(27,42,74,0.15)',
              background: 'transparent', font: '500 12px Inter, sans-serif', color: '#1B2A4A', cursor: 'pointer',
            }}
          >
            {updating === p.id ? '…' : p.accountStatus === 'active' ? 'Suspend' : 'Reactivate'}
          </button>
        </div>
      ))}
    </>
  )
}
